<form id="skillForm" #skillForm="ngForm">
  <div class="p-grid">
    <div class="p-col-12">
      <h4>Skills/Certification Information</h4>
    </div>
  </div>
  <div class="p-grid">
    <div class="p-col-6">
      <h6>Skill/Certification Name</h6>
      @if (skill) {
      <input pInputText fluid maxlength="255" name="name" [(ngModel)]="skill.name" required />
      }
    </div>
    <div class="p-col-2">
      <h6>Short Name</h6>
      @if (skill) {
      <input pInputText fluid maxlength="25" name="shortName" [(ngModel)]="skill.shortName" required />
      }
    </div>
    <div class="p-col-2">
      <h6>Years Valid</h6>
      @if (skill) {
      <input pInputText fluid pKeyFilter="pint" name="length" [(ngModel)]="skill.length" required />
      }
    </div>
  </div>
  <div class="p-grid">
    <div class="p-col-12 columnPadding">
      @if (skillForm.invalid && skillForm.submitted) {
      <div class="alert alert-danger" role="alert">
        There are errors on this page. Please correct the errors and resubmit.
      </div>
      }
    </div>
  </div>
  <div class="row-container" style="flex-direction: row-reverse;">
    <p-button type="submit" severity="success" [disabled]="saving" (click)="save(skillForm)" label="Save">
    </p-button>
    <p-button type="button" severity="warn" (click)="cancel()" label="Cancel">
    </p-button>
    <p-button type="button" (click)="delete()" severity="danger" [disabled]="disableDelete" label="Delete">
    </p-button>
  </div>
</form>